// extracted by mini-css-extract-plugin
export var aniSpin = "h_d";
export var el = "h_b";